module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-bar3-2eb87c7fa87502230affaa3c74c4a494.svg";